































import { Component } from '@niknevis/vue-modules'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import { Prop } from 'vue-property-decorator'
import Vue from 'vue'

@Component({
  components: {
    DateTooltipped,
    TesTr
  }
})
export default class AdminChangelogRow extends Vue {
  @Prop({ required: true }) props!: object
}
